// extracted by mini-css-extract-plugin
module.exports = {"statusContainer":"service-times_statusContainer_2PMIl","statusLoadingIcon":"service-times_statusLoadingIcon_1xOHp"};